import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SessionState {
	token: string | undefined;
	setConnection: (session: string) => void;
}

export const useSessionStore = create<SessionState>()(
	persist(
		(set) => ({
			token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJrZXkiOiI3ODQxY2FmYy02NjhjLTQ2ZmEtODliOC03YmZjOTUyZDhlZWEiLCJpYXQiOjE3NzM5MzQwMzUsImV4cCI6MTgwNTQ3MDAzNX0.tAIOowFAL289VMXIm195wfWiyYcuThN_B-5Vz4ZmrTY',
			setConnection: (token: string) => set({ token: token }),
		}),
		{
			name: 'session-storage',
		},
	),
);
